module.exports = __webpack_public_path__ + "img/association_node.bd6e7702.svg";